import { useNotify, useRecordContext, useRefresh, useTranslate } from 'react-admin'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import { blue } from 'src/assets/colors'
import { getDay } from '../../helper/getDay'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISION_VIEW_CANCEL_SUPPLIER } from 'src/helper/Permission'
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LoadingButton } from '@mui/lab'
import { itemServices } from 'src/services/reservation/item/item.service'

export const HotelCancellation = ({ autoCancelDate, cancellations }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const item = useRecordContext()
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [newCancelationDate, setNewCancelationDate] = useState(autoCancelDate)
  const [loadingDateUpdate, setLoadingDateUpdate] = useState(false)
  const [cancelId, setCancelId] = useState(null)
  useEffect(()=>{
    if(cancelId){
      setOpenEditDialog(true)
      const cancelDate = cancellations.find(cancel=>cancel.id === cancelId)?.date ?? ''
      setNewCancelationDate(cancelDate)
    }
  },[cancelId])

  const onUpdateCancelationDate = async() =>{
    if(newCancelationDate){
      const dateParte = newCancelationDate.toISOString()?.split('T')[0];
      if(cancelId){
        setLoadingDateUpdate(true)
        await itemServices.updateAutoncancelDate(cancelId, dateParte).then(()=>{
          notify('ra.notification.due_date_success',{type:'success'})
          setOpenEditDialog(false)
          refresh()
          setCancelId(null)
        }).catch(()=>{
          notify('ra.notification.due_date_error',{type:'error'})
        }).finally(()=>{
          setLoadingDateUpdate(false)
        })
      } else {
        await itemServices.updateAutoncancelDateItem(item.item_id, dateParte).then(()=>{
          notify('ra.notification.due_date_success',{type:'success'})
          setOpenEditDialog(false)
          refresh()
        }).catch(()=>{
          notify('ra.notification.due_date_error',{type:'error'})
        }).finally(()=>{
          setLoadingDateUpdate(false)
        })
      }
    }
    
  }
  const onClose = () =>{
    setCancelId(null)
    setOpenEditDialog(false)
  }
  const getCancellations = (title, items) => {
    if (items) {
      return (
        <>
          <Typography variant='h7' component='div' fontWeight={600}>
            {title}
          </Typography>
          <Box style={{ padding: '10px' }}>
            {items.map((cancellation, index) => (
              <Box className='cancellation_container' key={index}>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='div' fontWeight={600}>
                    {translate('ra.field.date')}:
                  </Typography>

                  <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <Typography variant='h7' component='div' className='cancellation_column_value'>
                      <EventIcon /> {getDay(cancellation?.date)}
                    </Typography>
                    {
                      cancellation.is_client_cancel && 
                      <EditIcon 
                        style={{cursor:'pointer', marginLeft:'10px'}} 
                        fontSize='small' 
                        color='info'
                        onClick={()=>setCancelId(cancellation.id)}
                      />
                    }
                  </div>
                </Box>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='span' fontWeight={600}>
                    {translate('ra.field.amount')}:
                  </Typography>
                  <Typography variant='h7' component='div' className='cancellation_column_value'>
                    $ {cancellation?.amount}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </>
      )
    }
  }

  if (cancellations && cancellations.length !== 0) {
    return (
      <Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 0px 10px 0px'}>
          {translate('ra.title.cancellation_cost')}
        </Typography>
        {hasPermissionFunction('cancel-info', PERMISION_VIEW_CANCEL_SUPPLIER) &&
          getCancellations(
            translate('ra.title.cancellation_cost_provider'),
            cancellations.filter((elem) => !elem.is_client_cancel)
          )}
        {getCancellations(
          translate('ra.title.cancellation_cost_client'),
          cancellations.filter((elem) => elem.is_client_cancel)
        )}
        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
          <ShowElement data={autoCancelDate} label={translate('ra.field.autocancel_date')} date />
          {
            autoCancelDate && 
              <EditIcon 
                style={{cursor:'pointer', marginLeft:'10px'}} 
                fontSize='small' color='info' 
                onClick={()=>{setOpenEditDialog(true); setNewCancelationDate(autoCancelDate)}}/>
          }
        </div>

        <Dialog open={openEditDialog} onClose={onClose}>
          <DialogTitle>
            {`${translate('ra.action.update')} ${translate('ra.field.autocancel_date')}`}
          </DialogTitle>
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
              <DatePicker
                  value={newCancelationDate|| null}
                  id='from'
                  onChange={(date) => setNewCancelationDate(date)}
                  renderInput={(params) => (
                    <TextField {...params} required  style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                  )}
                />
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onClose}
            >
              {translate('ra.action.close')}
            </Button>
            <LoadingButton
              onClick={onUpdateCancelationDate}
              loading={loadingDateUpdate}
            >
              {translate('ra.action.edit')}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }
}
